import { IntlShape } from "react-intl";

import getLabel from "helpers/getLabel";

const inputValues = (location: string, intl: IntlShape) => [
  {
    value: "organizational.cost_center",
    label: getLabel("Cost Center / WBS / Project #", "capitalize", location, true, true),
    fixed_value: false,
  },
  {
    value: "organizational.reason_code",
    label: getLabel("Reason code", "capitalize", location, true, true),
    fixed_value: false,
  },
  {
    value: "organizational.custom_field_01",
    label: getLabel("Custom field 01", "capitalize", location, true, true),
    fixed_value: false,
  },
  {
    value: "organizational.custom_field_02",
    label: getLabel("Custom field 02", "capitalize", location, true, true),
    fixed_value: false,
  },
  {
    value: "organizational.custom_field_03",
    label: getLabel("Custom field 03", "capitalize", location, true, true),
    fixed_value: false,
  },
  {
    value: "invited_modes",
    label: intl.formatMessage({ id: "general.freightMode", defaultMessage: "Freight Mode" }),
    fixed_value: true,
    available: true,
  },
  {
    value: "schedule.pickup_country",
    label: intl.formatMessage({ id: "settings.prefills.pickupCountry", defaultMessage: "Pickup Country" }),
    fixed_value: true,
    available: true,
  },
  {
    value: "schedule.stop1_country",
    label: intl.formatMessage({ id: "settings.prefills.deliveryCountry", defaultMessage: "Delivery Country" }),
    fixed_value: true,
    available: true,
  },
];

const outputValues = (location: string, intl: IntlShape) => [
  {
    value: "shipment.custom_longfield_01",
    label: getLabel("Custom longfield 01", "capitalize", location, true, true),
    fixed_value: false,
  },
  {
    value: "organizational.custom_field_01",
    label: getLabel("Custom field 01", "capitalize", location, true, true),
    fixed_value: false,
  },
  {
    value: "organizational.custom_field_02",
    label: getLabel("Custom field 02", "capitalize", location, true, true),
    fixed_value: false,
  },
  {
    value: "organizational.custom_field_03",
    label: getLabel("Custom field 03", "capitalize", location, true, true),
    fixed_value: false,
  },
  {
    value: "schedule.pickup_address_name",
    label: intl.formatMessage({ id: "quote-request-detail.pickupCompany", defaultMessage: "Pickup Company" }),
    available: true,
    fixed_value: false,
  },
  {
    value: "schedule.pickup_street",
    label: intl.formatMessage({
      id: "settings.prefills.pickupAddressLine",
      defaultMessage: "Pickup address line",
    }),
    available: true,
    fixed_value: false,
  },
  {
    value: "schedule.pickup_street_line2",
    label: intl.formatMessage({
      id: "settings.prefills.pickupAddressLine2",
      defaultMessage: "Pickup address line 2",
    }),
    available: true,
    fixed_value: false,
  },
  {
    value: "schedule.pickup_zipcode",
    label: intl.formatMessage({
      id: "settings.prefills.pickupZipcode",
      defaultMessage: "Pickup zipcode",
    }),
    available: true,
    fixed_value: false,
  },
  {
    value: "schedule.pickup_city",
    label: intl.formatMessage({
      id: "general.pickupCity",
      defaultMessage: "Pickup city",
    }),
    available: true,
    fixed_value: false,
  },
  {
    value: "schedule.pickup_country",
    label: intl.formatMessage({
      id: "settings.prefills.pickupCountry",
      defaultMessage: "Pickup country",
    }),
    available: true,
    fixed_value: true,
  },
  {
    value: "schedule.pickup_contact_name",
    label: intl.formatMessage({
      id: "new-request.schedule.pickupContactName",
      defaultMessage: "Pickup contact name",
    }),
    available: true,
    fixed_value: false,
  },
  {
    value: "schedule.pickup_contact_email",
    label: intl.formatMessage({
      id: "settings.prefills.pickupContactEmail",
      defaultMessage: "Pickup contact email",
    }),
    available: true,
    fixed_value: false,
  },
  {
    value: "schedule.pickup_contact_phone",
    label: intl.formatMessage({
      id: "tracking.pickupContactPhone",
      defaultMessage: "Pickup contact phone",
    }),
    available: true,
    fixed_value: false,
  },
  {
    value: "schedule.stop1_address_name",
    label: intl.formatMessage({
      id: "quote-request-detail.deliveryCompany",
      defaultMessage: "Delivery company",
    }),
    available: true,
    fixed_value: false,
  },
  {
    value: "schedule.stop1_street",
    label: intl.formatMessage({
      id: "settings.prefills.deliveryAddressLine",
      defaultMessage: "Delivery address line",
    }),
    available: true,
    fixed_value: false,
  },
  {
    value: "schedule.stop1_street_line2",
    label: intl.formatMessage({
      id: "settings.prefills.deliveryAddressLine2",
      defaultMessage: "Delivery address line 2",
    }),
    available: true,
    fixed_value: false,
  },
  {
    value: "schedule.stop1_zipcode",
    label: intl.formatMessage({
      id: "settings.prefills.deliveryZipcode",
      defaultMessage: "Delivery zipcode",
    }),
    available: true,
    fixed_value: false,
  },
  {
    value: "schedule.stop1_city",
    label: intl.formatMessage({
      id: "general.deliveryCity",
      defaultMessage: "Delivery city",
    }),
    available: true,
    fixed_value: false,
  },
  {
    value: "schedule.stop1_country",
    label: intl.formatMessage({
      id: "quote-request-detail.deliveryCountry",
      defaultMessage: "Delivery country",
    }),
    available: true,
    fixed_value: true,
  },
  {
    value: "schedule.stop1_contact_name",
    label: intl.formatMessage({
      id: "new-request.quote-confirmation.schedule.deliveryContactName",
      defaultMessage: "Delivery contact name",
    }),
    available: true,
    fixed_value: false,
  },
  {
    value: "schedule.stop1_contact_email",
    label: intl.formatMessage({
      id: "settings.prefills.deliveryContactEmail",
      defaultMessage: "Delivery contact email",
    }),
    available: true,
    fixed_value: false,
  },
  {
    value: "schedule.stop1_contact_phone",
    label: intl.formatMessage({
      id: "tracking.deliveryContactPhone",
      defaultMessage: "Delivery contact phone",
    }),
    available: true,
    fixed_value: false,
  },
  {
    value: "service.incoterms",
    label: intl.formatMessage({
      id: "new-request.service.incoterms",
      defaultMessage: "Incoterms",
    }),
    available: true,
    fixed_value: true,
  },
  {
    value: "service.incoterm_instructions",
    label: intl.formatMessage({
      id: "new-request.service.incotermInstructions",
      defaultMessage: "Incoterm instructions",
    }),
    available: true,
    fixed_value: false,
  },
  {
    value: "service.export_clearance",
    label: intl.formatMessage({
      id: "tableHeaders.exportClearance",
      defaultMessage: "Export clearance",
    }),
    available: true,
    fixed_value: true,
  },
  {
    value: "service.export_clearance_instructions",
    label: intl.formatMessage({
      id: "quote-request-detail.exportClearanceInstructions",
      defaultMessage: "Export clearance instructions",
    }),
    available: true,
    fixed_value: false,
  },

  {
    value: "service.import_clearance",
    label: intl.formatMessage({
      id: "quote-request-detail.importClearance",
      defaultMessage: "Import clearance",
    }),
    available: true,
    fixed_value: true,
  },
  {
    value: "service.import_clearance_instructions",
    label: intl.formatMessage({
      id: "quite-request-detail.importClearanceInstructions",
      defaultMessage: "Import clearance instructions",
    }),
    available: true,
    fixed_value: false,
  },
  {
    value: "service.transit_clearance",
    label: intl.formatMessage({
      id: "quote-request-detail.transitClearance",
      defaultMessage: "Transit clearance",
    }),
    available: true,
    fixed_value: true,
  },
  {
    value: "service.transit_clearance_instructions",
    label: intl.formatMessage({
      id: "quote-request-detail.transitClearanceInstructions",
      defaultMessage: "Transit clearance instructions",
    }),
    available: true,
    fixed_value: false,
  },
  {
    value: "service.insurance",
    label: intl.formatMessage({
      id: "general.insurance",
      defaultMessage: "Insurance",
    }),
    available: true,
    fixed_value: true,
  },
  {
    value: "service.insurance_instructions",
    label: intl.formatMessage({
      id: "new-request.service.insuranceInstructions",
      defaultMessage: "Insurance instructions",
    }),
    available: true,
    fixed_value: false,
  },
];

const insuranceOptions = (intl: IntlShape) => [
  {
    value: "false",
    label: intl.formatMessage({
      id: "general.no",
      defaultMessage: "No",
    }),
  },
  {
    value: "true",
    label: intl.formatMessage({
      id: "general.yes",
      defaultMessage: "Yes",
    }),
  },
];

export { inputValues, outputValues, insuranceOptions };
